// Security headers utility for enhanced protection

export const setSecurityHeaders = () => {
  // Content Security Policy (relaxed for iframe functionality)
  const cspContent = [
    "default-src 'self'",
    "script-src 'self' 'unsafe-inline' 'unsafe-eval' https://cdn.jsdelivr.net https://unpkg.com",
    "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com",
    "font-src 'self' https://fonts.gstatic.com",
    "img-src 'self' data: https: blob:",
    "connect-src 'self' https://*.supabase.co wss://*.supabase.co",
    "frame-src 'self'",
    "object-src 'none'",
    "base-uri 'self'",
    "form-action 'self'"
  ].join('; ');

  // Set meta tags for security headers
  const setMetaTag = (name: string, content: string) => {
    let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', name);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
  };

  const setHttpEquiv = (equiv: string, content: string) => {
    let meta = document.querySelector(`meta[http-equiv="${equiv}"]`) as HTMLMetaElement;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('http-equiv', equiv);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
  };

  // Apply security headers via meta tags (where possible)
  setHttpEquiv('Content-Security-Policy', cspContent);
  setHttpEquiv('X-Content-Type-Options', 'nosniff');
  // Skip X-Frame-Options to avoid console warnings
  // setHttpEquiv('X-Frame-Options', 'SAMEORIGIN');
  setHttpEquiv('Referrer-Policy', 'strict-origin-when-cross-origin');
  
  // Additional security meta tags
  setMetaTag('robots', 'noindex, nofollow'); // Prevent indexing of admin areas
};

export const removeSecurityHeaders = () => {
  // Remove restrictive headers for public pages
  const headers = [
    'Content-Security-Policy',
    'X-Frame-Options',
    'X-Content-Type-Options',
    'Referrer-Policy'
  ];
  
  headers.forEach(header => {
    const meta = document.querySelector(`meta[http-equiv="${header}"]`);
    if (meta) {
      meta.remove();
    }
  });
  
  // Update robots meta for public pages
  let robotsMeta = document.querySelector('meta[name="robots"]') as HTMLMetaElement;
  if (robotsMeta) {
    robotsMeta.setAttribute('content', 'index, follow');
  }
};